import { Mapper } from "../../../../../core/base";
import { LocationMockEntity } from "./location-mock-entity";
import { Location } from "../../../../../core/domain";
import { DateTime } from "luxon";

export class LocationMockRepositoryMapper extends Mapper<LocationMockEntity, Location> {

  mapFrom(param: LocationMockEntity): Location {
    return {
      id: param.id,
      locationName: param.name,
      address: param.address,
      servicesCount: param.servicesCount,
      createdAt: DateTime.now()
    };
  }

  mapTo(param: Location): LocationMockEntity {
    return {
      id: param.id,
      name: param.locationName,
      address: param.address,
      servicesCount: param.servicesCount
    };
  }
}
